// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"507":"cb361b16","773":"e3934794","926":"b3a52844"}[chunkId] + ".chunk.js";
};